export default {
  language: (state) => state.app.language,
  userInfo: (state) => state.user.userInfo,
  examInfo: (state) => state.user.examInfo,
  firstLoginFlag: (state) => state.user.firstLoginFlag,
  examConfig: (state) => state.user.examConfig,
  selectForm: (state) => state.user.selectForm,
  notice: (state) => state.user.notice,
  pathFlag: (state) => state.user.pathFlag,
  pathParams: (state) => state.user.pathParams,
}
